import React, { useState, useEffect, useContext } from "react";
import Select from "react-select";
import { Link, useHistory } from "react-router-dom";
import OutsideClickHandler from "react-outside-click-handler";
import ProcessPropInfo from "../../../components/ProcessPropInfo";
import AnalistChecklist from "../../../components/AnalistChecklist";
import { list_questions } from "../../../services/questions";
import AddBackground from "../../../components/AddBackground";
import api from "../../../services/api";
import { Content, Container } from "./styles";
import QuestionContext from "../../../contexts/QuestionContext";

interface ListProps {
	title: string;
	id: number;
}

function StepFive() {
	const [questionsList, setQuestionsList] = useState<ListProps[]>([]);

	const [show, setShow] = useState("hidden");

	const [selectedAnswer, setSelectedAnswer] = useState<any>();

	const history = useHistory();
	const backButton = () => history.goBack();

	// Ver comentarios no contexto para entender
	const { stepThreeValues, processId, documents, setStepThreeValues } =
		useContext(QuestionContext);

	const handleAnswer = (id: number, answer: number, documentData: any) => {
		setStepThreeValues((state: any) => ({
			...state,
			...{
				[documentData.id]: {
					...state[documentData.id],
					...{ [id]: { answer } },
				},
			},
		}));
	};

	const handleJustificationChange = (
		id: number,
		justification: string,
		documentData: any,
	) => {
		setStepThreeValues((state: any) => ({
			...state,
			[documentData.id]: {
				...documentData.id,
				[id]: { answer: 2, justification },
			},
		}));
	};

	useEffect(() => {
		(async () => {
			try {
				const response = await list_questions(1);

				setQuestionsList(response.data);
			} catch (error) {
				return error;
			}
		})();
	}, []);

	const status = [
		{
			label: "Aprovado",
			color: "#228D19",
			value: 6,
		},
		{ label: "Reprovado", color: "#D11919", value: 4 },
		{ label: "pendente", color: "#E8652C", value: 6 },
	];

	const colorStyles = {
		option: (styles: any, { data }: any) => ({
			...styles,
			color: data.color,
			backgroundColor: data.selectProps ? "#c4c4c4" : null,
		}),
		singleValue: (styles: any, { data }: any) => ({
			...styles,
			color: data.color,
		}),
	};

	const handleSubmit = () => {
		const changeStatus = async () => {
			try {
				const response = await api.patch(
					`/data/process&id=${processId}/status`,
					{
						status: selectedAnswer,
					},
				);

				console.log(response);
				return response;
			} catch (error) {
				return error;
			}
		};

		changeStatus();
		setShow("show");
	};

	const getAnswersByDocument = (document: any) => {
		const filteredQuestions = questionsList.filter((question: any) => {
			const questionTags = question.documentsTag.map(
				(tag: any) => tag.id,
			);

			return questionTags.includes(document.documentTagId);
		});

		return filteredQuestions;
	};

	return (
		<Container>
			<Content>
				<div className='left-side'>
					<div className='quests-wrapper'>
						<div className='header'>
							<p className='txt-header'>Perguntas Reprovadas</p>
						</div>
						<div className='quests'>
							{Object.keys(stepThreeValues).map((documentId) => {
								const document = documents.filter(
									(doc: any) =>
										doc.id === parseInt(documentId),
								)[0];

								// REPENSAR
								// Todas as questões rejeitdas devem ser separadas por documento

								return (
									<>
										{getAnswersByDocument(document).map(
											(item: any, key: number) =>
												stepThreeValues[documentId][
													item.id
												]?.justification ? (
													<>
														<p>
															{key === 0
																? document
																		.documentTag
																		.name
																: ""}
														</p>
														<AnalistChecklist
															title={item.title}
															id={item.id}
															key={item.id}
															document={document}
															selectedDocumentId={
																document.id
															}
															handleAnswer={(
																value: number,
															) => {
																handleAnswer(
																	item.id,
																	value,
																	document,
																);
															}}
															handleJustificationChange={
																handleJustificationChange
															}
														/>
													</>
												) : (
													""
												),
										)}
									</>
								);
							})}
						</div>
					</div>
					<div className='final-status'>
						<label>
							Status final da análise do processo
							<Select
								options={status}
								placeholder='SELECIONAR'
								styles={colorStyles}
								onChange={(newValue, action) => {
									if (action.action === "select-option")
										setSelectedAnswer(newValue?.value);
								}}
								noOptionsMessage={() => "Opção não existe"}
							/>
						</label>
					</div>
					<div className='button-wrapper'>
						<button onClick={backButton} id='cancel-button'>
							VOLTAR
						</button>
						{selectedAnswer ? (
							<button id='submit' onClick={handleSubmit}>
								Finalizar Análise
							</button>
						) : (
							<button id='not-ready'>Finalizar Análise</button>
						)}
					</div>
				</div>
				<ProcessPropInfo />
			</Content>

			<AddBackground className={show}>
				<OutsideClickHandler onOutsideClick={() => setShow("hidden")}>
					<div className='pop-up'>
						<p className='pop-header'>
							Análise finalizada com sucesso!
						</p>

						<label>
							Status de análise:
							{selectedAnswer === 3 ? (
								<p className='pop-up-text'>Aprovado</p>
							) : selectedAnswer === 4 ? (
								<p className='pop-up-text'>Reprovado</p>
							) : selectedAnswer === 6 ? (
								<p className='pop-up-text'>Pendente</p>
							) : null}
						</label>

						{selectedAnswer === 6 || selectedAnswer === 3 ? (
							<p className='pop-up-text' id='aproved'>
								Aguardando Digitador
							</p>
						) : selectedAnswer === 4 ? (
							<p className='pop-up-text' id='reproved'>
								Reprovado
							</p>
						) : null}

						<Link className='link-button' to='/consulta'>
							<button>OK</button>
						</Link>
					</div>
				</OutsideClickHandler>
			</AddBackground>
		</Container>
	);
}

export default StepFive;
